/* -----------------Globals--------------- */
import { Stack, useLocalSearchParams } from "expo-router";

/* -----------------Child components--------------- */
import Box from "@memorang/ui/src/components/Box";
import ScrollContainer from "@memorang/ui/src/components/ScrollContainer";
import CustomMarkdownRenderer from "components/CustomMarkdownRenderer";
import ModalHeader from "components/ModalHeader";

const InfoModal = () => {
	const { title, body } = useLocalSearchParams<{
		title: string;
		body: string;
	}>();

	return (
		<>
			<Stack.Screen
				options={{
					presentation: "modal",
					headerShown: true,
					header: () => (
						<ModalHeader backIcon="arrow-left" headerTitle={title || "Info"} />
					),
				}}
			/>
			<ScrollContainer>
				<Box padding={16}>
					<CustomMarkdownRenderer text={body} />
				</Box>
			</ScrollContainer>
		</>
	);
};

export default InfoModal;
